import React, { useEffect, useRef, useState } from "react";
import InputField from "../shared-components/InputField";
import { PersonFormStateError } from "./PersonFormErrorState";
import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import { classNames } from "../utils";

type Props = {
  onChange?: (date: string) => void;
  error?: PersonFormStateError;
  prefill?: string;
  index: number;
  _name: string;
  _label: string;
  classes?: string;
};
const MAX_DATE = new Date("2050-01-01").toISOString().split("T")[0];
const PersonFormStringDate = ({
  onChange,
  error,
  index,
  _name,
  _label,
  prefill,
  classes,
}: Props) => {
  const [field, setField] = useState("");
  const picker = useRef<HTMLInputElement>(null);

  const handleChange = (item: string) => {
    onChange?.(item);
    setField(item);
  };

  const handleIconClick = (inputRef: React.RefObject<HTMLInputElement>) => {
    if (inputRef.current) {
      (inputRef.current as any).showPicker();
    }
  };

  useEffect(() => {
    if (prefill) {
      handleChange(prefill);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefill]);

  return (
    <div className="relative">
      <CalendarDaysIcon
        className="w-6 absolute right-5 top-9"
        onClick={() => handleIconClick(picker)}
      ></CalendarDaysIcon>

      <InputField
        handleChange={(e) => {
          const date = new Date(e.target.value);
          if (date > new Date(MAX_DATE)) {
            handleChange(MAX_DATE);
          } else {
            handleChange(e.target.value);
          }
        }}
        name={_name}
        placeholder=""
        value={field}
        label={_label}
        classes={"mr-4"}
        className={classNames(
          error?.degrees?.end_date?.[index] ? "border-rose-600" : "",
          "w-full"
        )}
        type="date"
        maxLength={10}
        max={MAX_DATE}
      />
      <input
        className="invisible absolute bottom-0 left-0"
        type="date"
        ref={picker}
        onChange={(e) => {
          handleChange(e.target.value);
        }}
        max={MAX_DATE}
        maxLength={10}
      />
    </div>
  );
};

export default PersonFormStringDate;
